import axios from 'axios';
import { Toast } from 'vant';
import { dateFormatter } from '../utils/formatter';
import { NET_ERR_MSG, NET_REQUEST_SUCCESS, LOGIN_OUTTIME } from '../utils/constant';

// 初始化axios
const request = axios.create({
  timeout: 10000,
  headers: {
    // AUTHORIZATION:  `Bearer ${userInfo.token}`
  }
});

// 请求拦截
request.interceptors.request.use(config => {
  // 如果获取到token，则拼接到header里
  // if (userInfo.getToken()) {
  // 	config.headers['AUTHORIZATION'] = `Bearer ${userInfo.getToken()}`
  // }
  return config;
}, error => Promise.reject(error));

// 返回拦截
request.interceptors.response.use(res => {
  return res;
}, error => {
  Toast.fail(NET_ERR_MSG);
  return Promise.reject(error);
});


// // 请求参数包装
// const formatRequestData = (data = {}, method, config) => {
//   // 自定义超时时长
//   const { timeout } = config;

//   if (timeout) {
//     config.axiosConfig = { timeout };
//   }

//   if (method === 'get') {
//     return {
//       params: {
//         ...data
//       }
//     };
//   }
//   if (config.dataType === 'form') {
//     config.axiosConfig = config.axiosConfig || {};
//     config.axiosConfig.headers = {
//       'Content-Type': 'multipart/form-data;boundary=' + new Date().getTime()
//     };
//     return data;
//   }

//   return {
//     ...data
//   };

//   // if (method === 'get') {
//   // 	return {
//   // 		params: {
//   // 			timestamp: encodeURIComponent(dateFormatter(new Date(), 'yyyy-MM-dd hh:mm:ss')),
//   // 			data: encodeURIComponent(JSON.stringify(data))
//   // 		}
//   // 	}
//   // }
//   //
//   // // 参数包装，所有请求参数打包
//   // return {
//   // 	timestamp: dateFormatter(new Date(), 'yyyy-MM-dd hh:mm:ss'),
//   // 	data: encodeURIComponent(JSON.stringify(data))
//   // }
// };



// 请求参数包装
const formatRequestData = (data = {}, method, config) => {
  // 自定义超时时长
  const { timeout } = config;

  if (timeout) {
    config.axiosConfig = { timeout };
  }

  if (method === 'get') {
    return {
      params: {
        timestamp: encodeURIComponent(dateFormatter(new Date(), 'yyyy-MM-dd hh:mm:ss')),
        data: encodeURIComponent(JSON.stringify(data))
      }
    };
  }

  if (config.dataType === 'form') {
    config.axiosConfig = config.axiosConfig || {};
    config.axiosConfig.headers = {
      'Content-Type': 'multipart/form-data;boundary=' + new Date().getTime()
    };
  }

  // 参数包装，所有请求参数打包
  return {
    timestamp: dateFormatter(new Date(), 'yyyy-MM-dd hh:mm:ss'),
    data: encodeURIComponent(JSON.stringify(data))
  };
};

// 请求本体，逻辑包裹
function ajax(method, url = '', data, config = {}) {
  return new Promise((resolve, reject) => {
    // 以下异常，都面向开发，在console报错
    if (!url) {
      return reject(new Error({
        errMsg: 'url不能为空'
      }));
    }

    request[method](url, formatRequestData(data, method, config), config.axiosConfig).then(result => {
      const res = result.data;

      // 登录过期
      // TODO c端登录状态丢失
      if (res.code === '1000000010' || res.code === '1000000009') {
        Toast.fail(LOGIN_OUTTIME);
        reject();
        return;
      }
      const { successMsg, unhandleShowErr, errorMsg } = config;
      // 成功操作提示

      if (res.success) {
        if (successMsg) {
          Toast.success(successMsg || NET_REQUEST_SUCCESS);
        }
        resolve(res);
      } else {
        if (!unhandleShowErr) {
          Toast.fail(res.desc || NET_ERR_MSG);
        }
        if (errorMsg) {
          Toast.fail(errorMsg);
        }
        reject(res);
      }
    }).catch(reject);
  });
}

// 把参数改成formData
export const changeToFormData = (data = {}) => {
  const formData = new FormData();

  Object.entries(data).forEach(([key, value]) => formData.append(key, value));
  return formData;
};

// 用于对外暴露的requests对象
const requests = {

  get(url, data , config) {
    return ajax('get', url, data, config);
  },
  post(url, data , config) {
    return ajax('post', url, data, config);
  },
  upload(files, config, params) {
    const file = files[0];

    const { url, ...rest} = config;

    return ajax('post', url, changeToFormData({ ...params, file }), rest);
  },
  // config = {url: ..., timeout: ..., dataType: 'form'} 配置信息
  // params = {file: ..., ....} 表单参数
  upLoadFile(config, params) {
    const { url, ...rest} = config;

    return ajax('post', url, changeToFormData({ ...params }), rest);
  },
  // 用来接默认当做get请求的组件内请求
  ajax(requestType, data, config = {}) {
    if (config.method) {
      return ajax(config.method, requestType, data, config);
    }
    return ajax('get', requestType, data, config);
  }
};

export default {
  ...requests,
  install(Vue) {
    Vue.prototype.$ajax = requests.ajax;
    Vue.prototype.$ajax.get = requests.get;
    Vue.prototype.$ajax.post = requests.post;
    Vue.prototype.$ajax.upload = requests.upload;
    Vue.prototype.$ajax.upLoadFile = requests.upLoadFile;
  }
};
